import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';

const styles = theme => ({
    count:{
        position:'absolute',
        top:'50%',
        marginTop:'-12px',
        right:'0'
    },
    countMain: {
        backgroundColor:'#ff0000',
        color:'#ffffff',
        border:'1px solid #ff0000',
        padding:'3px 6px',
    },
    countSecondary: {
        backgroundColor:'#ffffff',
        color:'#000000',
        border:'1px solid #ff0000',
        padding:'3px 6px',
    }
});

function returnColor(status){
    if(status === 'Accepted'){
        return ('#5cb85c')
    }

    if(status === 'Not Accepted'){
        return ("#d9534f")
    }

    if(status === 'Approved'){
        return ("#5cb85c")
    }

    if(status === 'Requires Attention'){
        return ("#f0ad4e")
    }

    if(status === 'Missing'){
        return ("black")
    }
}

class DocumentStatus extends Component {

    render() {
        return (
          <div className={'kyc-label'} style={{backgroundColor:returnColor(this.props.status)}}>{this.props.date}</div>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(DocumentStatus)));
